import { UseApiLoaderResponse } from "../../../server/api/hooks/use-api-loader";
import { useMultiFormat } from "./use-multi-format";

type ContentTypeOption = {
  label: string;
  value: string;
  order: number | null;
};

export const useContentTypeOptions = (): UseApiLoaderResponse<ContentTypeOption[]> => {
  const multiformat = useMultiFormat();
  if (multiformat.loading || multiformat.error) return multiformat;
  return {
    ...multiformat,
    data: multiformat.data["content-types"]
      .map((contentType) => ({
        label: contentType["CE App Name"] ?? contentType["Content Type"],
        value: contentType["Content Type"],
        order: contentType["Order"],
      }))
      .sort(
        (a: ContentTypeOption, b: ContentTypeOption) =>
          (a.order ? a.order : 0) - (b.order ? b.order : 0),
      ),
  };
};
